import { TYPE_DICT } from './const';

const typeDict = {
  [TYPE_DICT.INCOMING]: 'incoming',
  [TYPE_DICT.OUTGOING]: 'outgoing',
};

export const type = (val) => typeDict[val];
